import { getClassLevel } from "../shared/getClassLevel";
import { evaluatePrimalStrike } from "./primalStrike";

const druidAdapter = Object.freeze({
  id: "druid",
  getClassLevel: (character) => getClassLevel(character, "druid"),
  evaluateOnHit: (context) => [evaluatePrimalStrike({ context })],
});

export default druidAdapter;
